// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
  <v-row dense class="pb-3">
    <v-col cols="12">
      <div>{{ title }}</div>
    </v-col>
    <v-col cols="4" v-for="obs in group" :key="obs.id">
      <observation-thumbnail :obsData="obs" @thumbClicked="thumbClicked(obs)"></observation-thumbnail>
    </v-col>
  </v-row>
</template>

<script>
import ObservationThumbnail from './observation-thumbnail.vue'
import NoctuaSkyClient from '../../noctuasky-client'
import swh from '@/assets/sw_helpers.js'
import Moment from 'moment'

export default {
  props: ['obsGroupData'],
  data: function () {
    return {
    }
  },
  computed: {
    group: function () {
      const arr = this.obsGroupData.f1.slice()
      arr.sort((a, b) => { return b.time - a.time })
      return arr
    },
    title: function () {
      if (this.obsGroupData.f0 !== undefined) {
        var dateMin = new Date()
        dateMin.setMJD(this.obsGroupData.groupDate.min)
        dateMin = Moment(dateMin)
        var dayString = dateMin.date()
        var humanFriendlyDaytime = 'Evening'
        if (this.obsGroupData.f0 > 1) {
          var dateMax = new Date()
          dateMax.setMJD(this.obsGroupData.groupDate.max)
          dateMax = Moment(dateMax)
          if (dateMin.date() !== dateMax.date()) {
            dayString = dateMin.date() + '-' + dateMax.date()
            humanFriendlyDaytime = 'Night'
          } else {
            if (dateMin.hours() < 12) {
              humanFriendlyDaytime = 'Morning'
            }
          }
        }
        var loc = NoctuaSkyClient.locations.get(this.group[0].location)
        var locName = 'Unknown Location'
        if (loc && loc.short_name) {
          locName = loc.short_name
        }
        if (!loc && this.group[0].location === 'current') {
          locName = this.$store.state.currentLocation.short_name
        }
        return dayString + ' ' + swh.monthNames[dateMin.month()] + ', ' + humanFriendlyDaytime + (locName.startsWith('Near ') ? ' ' + locName : ' in ' + locName)
      }
      return ''
    }
  },
  methods: {
    thumbClicked: function (obs) {
      this.$emit('thumbClicked', obs)
    }
  },
  components: { ObservationThumbnail }
}
</script>

<style>
</style>
